import React from 'react'
import { Link } from 'react-router-dom'
import { companyInfo } from '../data'

export default function Footer() {
  const showCvr = companyInfo.cvr && companyInfo.cvr !== '0000000' && companyInfo.cvr !== ''

  return (
    <footer className="bg-white text-neutral-800 border-t border-neutral-200">
      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
        {/* Brand Column */}
        <div className="flex flex-col gap-4">
          <Link to="/" className="flex items-center">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-20 md:h-24 lg:h-28 w-auto max-w-[280px] object-contain"
            />
          </Link>
          <p className="text-sm text-neutral-600 leading-relaxed">
            {companyInfo.description}
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-bold uppercase tracking-wider text-neutral-900">Hurtige links</h3>
          <ul className="flex flex-col gap-2.5 text-sm text-neutral-600">
            <li>
              <Link to="/" className="hover:text-black transition-colors duration-150">Forside</Link>
            </li>
            <li>
              <Link to="/galleri" className="hover:text-black transition-colors duration-150">Galleri</Link>
            </li>
            <li>
              <Link to="/priser" className="hover:text-black transition-colors duration-150">Priser</Link>
            </li>
            <li>
              <Link to="/om-os" className="hover:text-black transition-colors duration-150">Om os</Link>
            </li>
            <li>
              <Link to="/kontakt" className="hover:text-black transition-colors duration-150">Kontakt</Link>
            </li>
          </ul>
        </div>

        {/* Services Links */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-bold uppercase tracking-wider text-neutral-900">Vores ydelser</h3>
          <ul className="flex flex-col gap-2.5 text-sm text-neutral-600">
            <li>
              <Link to="/ydelser/privat-rengoering" className="hover:text-black transition-colors duration-150">Privat rengøring</Link>
            </li>
            <li>
              <Link to="/ydelser/housekeeping" className="hover:text-black transition-colors duration-150">Housekeeping</Link>
            </li>
            <li>
              <Link to="/ydelser/erhvervsrengoering" className="hover:text-black transition-colors duration-150">Erhvervsrengøring</Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-bold uppercase tracking-wider text-neutral-900">Kontakt os</h3>
          <ul className="flex flex-col gap-3 text-sm text-neutral-600">
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-location-dot mt-1 text-black"></i>
              <span>{companyInfo.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-black"></i>
              <a href={`tel:${companyInfo.phone.replace(/\s+/g, '')}`} className="hover:text-black transition-colors duration-150">
                {companyInfo.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-black"></i>
              <a href={`mailto:${companyInfo.email}`} className="hover:text-black transition-colors duration-150">
                {companyInfo.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-clock mt-1 text-black"></i>
              <span>{companyInfo.openingHours}</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-neutral-200 bg-neutral-50 py-6 text-center text-xs text-neutral-500">
        <div className="mx-auto max-w-7xl px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {new Date().getFullYear()} {companyInfo.name}. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-6">
            {showCvr && (
              <span>CVR-nr: {companyInfo.cvr}</span>
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}
